<template>
  <div style="padding: 0!important">
    <textarea rows="7" v-model="value" v-bind:name="inputname" class="form-control" v-on:keyup="counter"></textarea>
    <span v-bind:class="type">{{(max-value.length)}} caractères restant sur {{max}}</span>
  </div>
</template>

<script>
export default {
  name:'textCounter',
  props:['max','inputname','inputvalue'],
  data() {
    return {
      type:'alert-info',
      value:this.inputvalue
    }
  },
  methods:{
    counter() {
      if(this.value.length<this.max*0.2) {
        this.type='alert-warning';
      } else if(this.value.length>this.max) {
        this.type='alert-danger';
      } else if(this.value.length*1.3>this.max) {
        this.type='alert-warning';
      } else {
        this.type='alert-success';
      }
    }
  }
};
</script>

<style lang="css" scoped>
  div {
    padding: 10px;
  }
</style>
